import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

import DeviceDetailsView from './DeviceDetailsView'

class DeviceListView extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    devices: PropTypes.array.isRequired,
    onUpdateDevice: PropTypes.func.isRequired,
    onRemoveDevice: PropTypes.func.isRequired,
    timeseries: PropTypes.object.isRequired,
    onAddUnitTimeseries: PropTypes.func.isRequired,
    onSaveUnitTimeseries: PropTypes.func.isRequired,
  }

  static styles = (theme) => ({
    root: {
      marginTop: theme.spacing(3),
    },
  });

  render() {
    const {
      classes, devices, onUpdateDevice, onRemoveDevice, timeseries, onAddUnitTimeseries, onSaveUnitTimeseries,
    } = this.props
    const commonProps = {
      timeseries,
      onAddUnitTimeseries,
      onSaveUnitTimeseries,
      onUpdate: onUpdateDevice,
      onRemove: onRemoveDevice,
    }
    const devicesHtml = devices.map((d) => (
      <DeviceDetailsView key={d.id} device={d} {...commonProps} />
    ))

    return (
      <div className={classes.root}>
        {devicesHtml}
      </div>
    )
  }
}

export default withStyles(DeviceListView.styles)(DeviceListView)
